<template>
  <component
    :is="component"
    class="btn"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <slot name="iconLeft"></slot>
    <div class="inner">
      <slot></slot>
    </div>
    <slot name="iconRight"></slot>
  </component>
</template>
<script>
export default {
  computed: {
    // Switch component base on props
    component () {
      switch (true) {
        // if there is a "to" props, this is a router-link
        case !!this.$attrs.to:
          return 'router-link'
        // if there is a "href" props, this is a a tag
        case !!this.$attrs.href:
          return 'a'
        // else it is a regular button tag
        default:
          return 'button'
      }
    }
  }
}
</script>

<style lang="scss">
/* button */
.btn {
  appearance: none;
  transition: border-color $highlightDuration $easing, background-color $highlightDuration $easing;
  font-family: $ff-gotham-700;
  font-size: 1.2rem;
  text-align: center;
  width: auto;
  display: inline-flex;
  position: relative;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  backface-visibility: hidden;
  border: 1px solid transparent;
  padding: 1.45rem 2rem;

  @media screen and (min-width: $mq-medium) {
    padding: 1.45rem 2.8rem;
  }

  &.important {
    border:1px solid $brand-color;
    color: white;
    background: $brand-color;
    &:hover {
      border:1px solid lighten( $brand-color, 20% );
    }
    .svg-fill {
      fill: currentColor;
    }
  }

  &.primary {
    border:1px solid $c-text-paragraph;
    color: #000;
    background:white;
    &:hover {
      border:1px solid lighten( $c-text-paragraph, 20% );
    }
  }

  &.secondary {
    color: black;
    background:white;
    &:hover {
      background: darken( white, 20% );
    }
  }

  &.form {
    color: black;
    background:white;
    border: 0.2rem solid $c-borders;
    &:hover {
      background: darken( white, 20% );
    }
  }

  &.sending {
    cursor: progress;
    opacity: 1;
    > span {
      opacity: 0;
      transition: opacity 0.5s;
    }
  }
  &:disabled {
    cursor: progress;
    opacity: 0.6;
  }
  &.block {
    width: 100%;
  }
  &.sending:not(:disabled):before {
    content: '';
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -11px;
    width: 20px;
    height: 20px;
    border: 4px solid;
    border-left-color: transparent;
    border-radius: 50%;
    opacity: 0;
    transition-duration: 0.5s;
    transition-property: opacity;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-name: rotate;
    animation-timing-function: linear;
  }
  &:not(:disabled):after {
    content: '';
    display: inline-block;
    width: 0px;
    transition-delay: 0.5s;
    transition-duration: 0.75s;
    transition-property: width;
  }
  &:not(:disabled).sending {
    pointer-events: none;
    cursor: not-allowed;
  }
  &:not(:disabled).sending:before {
    transition-delay: 0.5s;
    transition-duration: 1s;
    opacity: 1;
  }
  &:not(:disabled).sending:after {
    transition-delay: 0s;
    width: 20px;
  }
  &::v-deep {
    .svg-icon {
      &:first-child {
        margin-right: 1.2rem;
      }
      &:last-child {
        margin-left: 1.2rem;
      }
    }
    .svg-fill {
      fill: $c-text-paragraph;
    }
  }
}
.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.5rem;
  height: 1.5rem;
  margin: -0.75rem 0 0 -0.75rem;

  & .path {
    stroke: white;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes rotate {
  0%    { transform: rotate(0deg); }
  100%  { transform: rotate(360deg); }
}
</style>
